import { Component, Input } from '@angular/core';

import { ProtectorState } from '@bpos/v1/my-bets';
import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';

@Component({
    selector: 'ms-my-bets-bet-protector',
    templateUrl: 'my-bets-bet-protector.html',
    standalone: false,
})
export class MyBetsBetProtectorComponent {
    @Input() betslip: MyBetsBetSlip;
    readonly protectorLostState: ProtectorState;

    constructor(public sitecoreMyBets: SitecoreMyBetsConfig) {
        this.protectorLostState = ProtectorState.Lost;
    }

    get isActive(): boolean {
        return this.betslip.betProtectorInformation && this.betslip.betProtectorInformation.state === ProtectorState.Open;
    }

    get protectionStatus(): string {
        switch (this.betslip.betProtectorInformation.state) {
            case ProtectorState.Open:
                return 'activeProtection';
            case ProtectorState.Won:
                return 'refundedProtection';
            default:
                return 'inActiveProtection';
        }
    }
}
